import { lang } from '@umu/ukit-lang';
import React, { useEffect, useMemo, useState } from 'react';

import { components } from 'common';
const { Loading } = components;
import { useIsMounted } from '@umu/umu-react-hooks';
import { CourseItem } from 'market/@marketCommon/components/courseItem/courseItem';
import { CircleItem } from 'market/@marketCommon/components/circleItem/circleItem';
import { getCategoryRecommends, IRecommendByCategory } from 'market/@marketCommon/dataServices/getCategoryRecommends';

import { ListType } from 'market/@marketCommon/interface/category';
import { ICourseResourceInfo, ICircleResourceInfo } from 'market/@marketCommon/interface/recommend';

import './categoryRecommends.scss';
import { If } from 'market/@marketCommon/components/common';
import { isShowLearningCliclePart } from 'market/@marketCommon/services/config';

/**
 * @desc 分类推荐聚合列表
 * @author Kody
 */
export const CategoryRecommends = () => {
    const isMountedRef = useIsMounted();
    const [data, setData] = useState<IRecommendByCategory[]>([]);

    useEffect(() => {
        getCategoryRecommends().then((res) => {
            if (res.data && isMountedRef.current) {
                setData(res.data.list || []);
            }
        });
    }, []);

    /**
     * 是否展示推荐
     * @param group
     * @param circle
     * @returns
     */
    const isShowCategoryRecommend = (group: ICourseResourceInfo[], circle: ICircleResourceInfo[]) => {
        if (group.length === 0 && circle.length === 0) {
            return false;
        }
        if (group.length === 0 && !isShowLearningCliclePart()) {
            return false;
        }
        return true;
    };

    const renderCourses = (courses: ICourseResourceInfo[], categoryId: string) => {
        if (!courses.length) {
            return null;
        }
        const list = courses.slice(0, 4).map((course) => {
            return <CourseItem key={course.encrypted_id} resourceInfo={course} />;
        });
        return (
            <div className="category-children">
                <div className="head">
                    {lang('课程')}
                    <a href={`/market/category/${categoryId}?type=${ListType.COURSE}`} className="more">
                        {lang('更多课程')}
                        <i className="iconfont icon-arrow-right" />
                    </a>
                </div>
                <div className="body category-children-body">{list}</div>
            </div>
        );
    };

    const renderCircles = (circles: ICircleResourceInfo[], categoryId: string) => {
        if (!circles.length) {
            return null;
        }
        const list = circles.slice(0, 3).map((circle) => {
            return <CircleItem key={circle.encrypted_id} resourceInfo={circle} />;
        });

        return (
            <div className="category-children">
                <div className="head">
                    {lang('学习圈')}
                    <a href={`/market/category/${categoryId}?type=${ListType.CIRCLE}`} className="more">
                        {lang('更多学习圈')}
                        <i className="iconfont icon-arrow-right" />
                    </a>
                </div>
                <div className="body clearfix">{list}</div>
            </div>
        );
    };

    const content = useMemo(() => {
        if (!data.length) {
            return <Loading />;
        }
        return data.map((item) => {
            if (!item.category_id || !item.children) {
                return null;
            }
            return (
                <div key={item.category_id}>
                    <If condition={isShowCategoryRecommend(item.children.group || [], item.children.circle || [])}>
                        <div className="market-category-recommend">
                            <div className="module-label">{item.category_name}</div>
                            {renderCourses(item.children.group || [], item.category_id)}
                            <If condition={isShowLearningCliclePart()}>
                                {renderCircles(item.children.circle || [], item.category_id)}
                            </If>
                        </div>
                    </If>
                </div>
            );
        });
    }, [data]);

    return <div className="market-category-recommends">{content}</div>;
};
